import { render, staticRenderFns } from "./addedit-escalationfactor-barrier.vue?vue&type=template&id=4cbd5b7e"
import script from "./addedit-escalationfactor-barrier.vue?vue&type=script&lang=js"
export * from "./addedit-escalationfactor-barrier.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports